<div *ngIf="!modelReady" class="content-loading">
   <fbdn-icon icon="loading"></fbdn-icon>
</div>
<bb-dynamic-form
   *ngIf="modelReady"
   [form]="form"
   [schema]="schema"
   [submitConfig]="submitConfig"
></bb-dynamic-form>
